(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rhp-editorial-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rhp-story-gallery')) {
    class RhpStoryGallery extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const button = event.target.closest('[data-rhp-story-thumb]');
        if (!button || !this.contains(button)) return;

        const mainImage = this.querySelector('.rhp-editorial-story__main-image');
        const source = button.dataset.imageSrc;
        if (!mainImage || !source) return;

        this.querySelectorAll('[data-rhp-story-thumb]').forEach((thumbnail) => {
          thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
        });

        mainImage.classList.add('is-changing');
        window.setTimeout(() => {
          mainImage.src = source;
          mainImage.removeAttribute('srcset');
          mainImage.alt = button.dataset.imageAlt || '';
          mainImage.classList.remove('is-changing');
        }, 140);
      };
    }

    customElements.define('rhp-story-gallery', RhpStoryGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-based-why"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initWhyMotion = () => {
      document.querySelectorAll('[data-rhp-why-motion]').forEach((section) => {
        if (section.dataset.motionReady === 'true') return;
        section.dataset.motionReady = 'true';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          section.classList.add('is-visible');
          return;
        }

        section.classList.add('is-ready');
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          },
          { threshold: 0.18 }
        );
        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhyMotion, { once: true });
    } else {
      initWhyMotion();
    }

    document.addEventListener('shopify:section:load', initWhyMotion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-cinema"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rhp-home-cinema')) {
    customElements.define(
      'rhp-home-cinema',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.revealTimer = 0;
          const { signal } = this.abortController;
          this.video = this.querySelector('video');
          this.button = this.querySelector('[data-cinema-toggle]');
          this.media = this.querySelector('[data-cinema-media]');
          if (!this.video || !this.button) return;

          this.button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggle();
          }, { signal });
          this.media?.addEventListener('click', () => {
            if (this.video.paused) {
              this.play();
            } else {
              this.reveal();
            }
          }, { signal });
          this.video.addEventListener('play', () => this.update(true), { signal });
          this.video.addEventListener('pause', () => this.update(false), { signal });
          this.video.addEventListener('loadeddata', () => {
            this.media.dataset.videoReady = 'true';
          }, { signal, once: true });

          this.update(false);

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.pause();
          } else {
            this.observer = new IntersectionObserver((entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.play();
            }, { rootMargin: '120px 0px', threshold: 0.1 });
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.observer?.disconnect();
          window.clearTimeout(this.revealTimer);
          this.video?.pause();
        }

        toggle() {
          if (this.video.paused) {
            this.play();
          } else {
            this.video.pause();
          }
        }

        play() {
          this.loadVideo();
          this.video.play().catch(() => this.update(false));
        }

        loadVideo() {
          if (this.video.dataset.loaded === 'true') return;
          const source = document.createElement('source');
          source.src = this.video.dataset.videoSrc;
          source.type = 'video/mp4';
          this.video.append(source);
          this.video.dataset.loaded = 'true';
          this.video.load();
        }

        reveal() {
          window.clearTimeout(this.revealTimer);
          this.button.dataset.visible = 'true';
          this.revealTimer = window.setTimeout(() => {
            delete this.button.dataset.visible;
          }, 1200);
        }

        update(isPlaying) {
          this.button.dataset.playing = String(isPlaying);
          if (!isPlaying) delete this.button.dataset.visible;
          const label = isPlaying ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
          this.button.setAttribute('aria-label', label);
          this.button.title = label;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-hero"] && !Shopify.designMode) return;
  try {
    
  const rhpRevealSelector = [
    '.rhp-home-product-heading',
    '.rhp-home-product-card',
    '.rhp-home-products__header',
    '.rhp-home-products__rail',
    '.rhp-editorial-story__content',
    '.rhp-editorial-story__media',
    '.rhp-format-comparison__stage',
    '.rhp-home-brand-story__content',
    '.rhp-home-brand-story__media',
    '.rhp-home-cinema__header',
    '.rhp-home-cinema__media',
    '.rhp-home-video-strip__header',
    '.rhp-home-video-strip__rail',
    '.rhp-home-reviews__header',
    '.rhp-home-reviews__rail',
    '.rhp-home-headline__inner',
    '.rhp-service-band__header',
    '.rhp-service-band__item',
    '.rhp-home-proof__header',
    '.rhp-home-proof__services',
    '.rhp-home-proof__mosaic',
    '.rhp-home-stats__statement',
    '.rhp-home-stats__item',
    '.rhp-home-guides__header',
    '.rhp-home-guides__article',
    '.rhp-home-faq__header',
    '.rhp-home-faq details',
    '.rhp-home-bookend__panel'
  ].join(',');

  const setupRhpHomeMotion = (root = document) => {
    const elements = root.querySelectorAll(rhpRevealSelector);
    if (!elements.length) return;

    document.documentElement.classList.add('rhp-motion-ready');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('rhp-reveal', 'rhp-reveal--visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('rhp-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    const revealCounts = new Map();

    elements.forEach((element) => {
      if (element.classList.contains('rhp-reveal')) return;
      const section = element.closest('.shopify-section') || element.parentElement;
      const revealIndex = revealCounts.get(section) || 0;
      revealCounts.set(section, revealIndex + 1);
      element.classList.add('rhp-reveal');
      element.style.setProperty('--rhp-reveal-delay', `${Math.min(revealIndex, 3) * 60}ms`);
      observer.observe(element);
    });
  };

  const setupRhpHomeShopBar = () => {
    const hero = document.querySelector('.rhp-home-hero');
    const bar = document.querySelector('[data-rhp-home-shop-bar]');
    if (!hero || !bar || bar.dataset.ready === 'true') return;

    bar.dataset.ready = 'true';
    let frame = 0;
    const scrollRoot = document.querySelector('.page-wrapper');
    const coveredSections = Array.from(document.querySelectorAll([
      '.rhp-home-products',
      '.rhp-home-shop-tiles',
      '.rhp-home-proof',
      '.rhp-format-comparison',
      '.rhp-home-reviews',
      '.rhp-home-video-strip'
    ].join(',')));
    const cinemaMedia = document.querySelector('.rhp-home-cinema__media');

    const getScrollTop = () => Math.max(window.scrollY || 0, scrollRoot?.scrollTop || 0);

    const update = () => {
      frame = 0;
      const previewBar = document.querySelector('#PBarNextFrameWrapper');
      const previewOffset = previewBar ? previewBar.getBoundingClientRect().height + 8 : 0;
      bar.style.setProperty('--rhp-preview-bar-offset', `${previewOffset}px`);
      const trigger = Math.min(hero.offsetHeight * 0.58, 430);
      const coveredSectionVisible = coveredSections.some((section) => {
        const rect = section.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      });
      const cinemaRect = cinemaMedia?.getBoundingClientRect();
      const cinemaVisible = cinemaRect ? cinemaRect.bottom > 0 && cinemaRect.top < window.innerHeight : false;
      const visible = getScrollTop() > trigger && !coveredSectionVisible && !cinemaVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    scrollRoot?.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  const setupRhpHomeBenefitsMarquee = (root = document) => {
    const selector = '.rhp-home-hero__benefits--marquee';
    const marquees = [
      ...(root instanceof Element && root.matches(selector) ? [root] : []),
      ...Array.from(root.querySelectorAll?.(selector) || [])
    ];

    marquees.forEach((marquee) => {
      const track = marquee.querySelector('.rhp-home-hero__benefits-track');
      const groups = Array.from(marquee.querySelectorAll('.rhp-home-hero__benefits-group'));
      const firstGroup = groups[0];

      if (!track || !firstGroup || groups.length < 2) return;

      let frame = 0;

      const measureGroupWidth = () => {
        const style = window.getComputedStyle(firstGroup);
        const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        const paddingLeft = parseFloat(style.paddingLeft || '0') || 0;
        const paddingRight = parseFloat(style.paddingRight || '0') || 0;
        const itemWidth = Array.from(firstGroup.children).reduce((width, item) => {
          return width + item.getBoundingClientRect().width;
        }, 0);

        return Math.ceil(Math.max(
          marquee.clientWidth,
          itemWidth + gap * Math.max(firstGroup.children.length - 1, 0) + paddingLeft + paddingRight
        ));
      };

      const refresh = () => {
        frame = 0;
        const groupWidth = measureGroupWidth();

        if (!groupWidth) return;

        track.style.setProperty('--rhp-benefits-group-width', `${groupWidth}px`);
        track.style.setProperty('--rhp-benefits-shift', `-${groupWidth}px`);
      };

      const schedule = () => {
        if (frame) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(refresh);
      };

      if (marquee.dataset.rhpBenefitsMarqueeReady !== 'true') {
        marquee.dataset.rhpBenefitsMarqueeReady = 'true';
        window.addEventListener('resize', schedule, { passive: true });
        document.fonts?.ready?.then(schedule);

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(schedule);
          observer.observe(marquee);
          observer.observe(firstGroup);
        }
      }

      schedule();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupRhpHomeMotion();
      setupRhpHomeShopBar();
      setupRhpHomeBenefitsMarquee();
    }, { once: true });
  } else {
    setupRhpHomeMotion();
    setupRhpHomeShopBar();
    setupRhpHomeBenefitsMarquee();
  }

  document.addEventListener('shopify:section:load', (event) => {
    setupRhpHomeMotion(event.target);
    setupRhpHomeShopBar();
    setupRhpHomeBenefitsMarquee(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rhp-product-rail')) {
    customElements.define(
      'rhp-product-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          const { signal } = this.abortController;

          this.addEventListener('pointerdown', (event) => this.startGesture(event), { signal });
          this.addEventListener('pointermove', (event) => this.moveGesture(event), { signal });
          this.addEventListener('pointerup', (event) => this.endGesture(event), { signal });
          this.addEventListener('pointercancel', (event) => this.endGesture(event), { signal });
          this.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
          this.addEventListener(
            'click',
            (event) => {
              if (!this.suppressClick) return;
              event.preventDefault();
              event.stopPropagation();
              this.suppressClick = false;
            },
            { capture: true, signal }
          );
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        startGesture(event) {
          if (event.pointerType !== 'mouse' || !event.isPrimary || event.button !== 0) return;
          this.pointerId = event.pointerId;
          this.startX = event.clientX;
          this.startY = event.clientY;
          this.startScrollLeft = this.scrollLeft;
          this.lastX = event.clientX;
          this.lastTime = event.timeStamp;
          this.velocity = 0;
          this.gestureAxis = '';
          this.suppressClick = false;
        }

        moveGesture(event) {
          if (event.pointerId !== this.pointerId) return;
          const deltaX = event.clientX - this.startX;
          const deltaY = event.clientY - this.startY;
          const distanceX = Math.abs(deltaX);
          const distanceY = Math.abs(deltaY);

          if (!this.gestureAxis) {
            if (Math.max(distanceX, distanceY) < 10) return;
            if (distanceY >= distanceX * 1.15) {
              this.gestureAxis = 'vertical';
              return;
            }
            if (distanceX < distanceY * 1.15) return;
            this.gestureAxis = 'horizontal';
            this.classList.add('is-dragging');
            this.setPointerCapture?.(event.pointerId);
          }

          if (this.gestureAxis !== 'horizontal') return;
          event.preventDefault();
          this.scrollLeft = this.startScrollLeft - deltaX;
          this.suppressClick = distanceX > 12;

          const elapsed = Math.max(event.timeStamp - this.lastTime, 1);
          this.velocity = (this.lastX - event.clientX) / elapsed;
          this.lastX = event.clientX;
          this.lastTime = event.timeStamp;
        }

        endGesture(event) {
          if (event.pointerId !== this.pointerId) return;
          if (this.gestureAxis === 'horizontal') {
            const momentum = Math.max(-1.5, Math.min(this.velocity, 1.5)) * 180;
            this.scrollTo({ left: this.scrollLeft + momentum, behavior: 'smooth' });
          }
          this.classList.remove('is-dragging');
          if (this.hasPointerCapture?.(event.pointerId)) this.releasePointerCapture(event.pointerId);
          this.pointerId = null;
          this.gestureAxis = '';
        }
      }
    );
  }

  const initRhpHomeProductTabs = (scope = document) => {
    scope.querySelectorAll('.rhp-home-products').forEach((section) => {
      if (section.dataset.rhpTabsReady === 'true') return;

      const tabs = Array.from(section.querySelectorAll('[data-rhp-product-filter]'));
      const cards = Array.from(section.querySelectorAll('[data-rhp-filter-tags]'));
      const rail = section.querySelector('.rhp-home-products__rail');
      if (!tabs.length || !cards.length) return;

      section.dataset.rhpTabsReady = 'true';

      const activateTab = (activeTab) => {
        const filter = activeTab.dataset.rhpProductFilter;

        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        cards.forEach((card) => {
          const tags = (card.dataset.rhpFilterTags || '').split(/\s+/);
          card.hidden = !tags.includes(filter);
        });

        rail?.scrollTo({ left: 0, behavior: 'smooth' });
      };

      tabs.forEach((tab, index) => {
        tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;

        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        });
      });
    });
  };

  const rhpHomeProductsCartIcon = `
    <svg class="bbw-atc__icon" viewBox="0 0 15 17" fill="none" aria-hidden="true" focusable="false">
      <path d="M6.40625 0C7.42331 0 8.39893 0.403967 9.11816 1.12305C9.83733 1.84222 10.2421 2.81791 10.2422 3.83496V3.85645H12.8125V9.74414C12.6078 9.71838 12.3992 9.70312 12.1875 9.70312C11.9757 9.70313 11.7673 9.71835 11.5625 9.74414V5.10645H10.2422V6.40625H8.99219V5.10645H3.82129V6.40625H2.57129V5.10645H1.25V12.834C1.25005 13.1786 1.38716 13.5092 1.63086 13.7529C1.8746 13.9966 2.20513 14.1338 2.5498 14.1338H7.25977C7.24159 14.3063 7.23242 14.4818 7.23242 14.6592C7.23244 14.9053 7.25048 15.1473 7.28516 15.3838H2.5498C1.87361 15.3838 1.22523 15.1148 0.74707 14.6367C0.268949 14.1586 5.35364e-05 13.5102 0 12.834V3.85645H2.57129V3.83496C2.5714 2.81792 2.97517 1.84222 3.69434 1.12305C4.41355 0.403901 5.38918 5.04216e-05 6.40625 0ZM6.40625 1.25C5.7207 1.25005 5.06291 1.52211 4.57812 2.00684C4.09338 2.49158 3.8214 3.14944 3.82129 3.83496V3.85645H8.99219V3.83496C8.99208 3.14943 8.71913 2.49159 8.23438 2.00684C7.74956 1.52218 7.09178 1.25 6.40625 1.25Z" fill="white"></path>
      <path d="M12.6758 12.501V14.0117H14.1875V14.8232H12.6758V16.335H11.8643V14.8232H10.3535V14.0117H11.8643V12.501H12.6758Z" fill="white" stroke="white" stroke-width="0.2"></path>
    </svg>
  `;

  const repairRhpHomeProductButtons = (scope = document) => {
      const labelText = document.documentElement.lang?.toLowerCase().startsWith('es') ? 'AGREGAR AL CARRITO' : 'ADD TO CART';

      scope.querySelectorAll('.rhp-home-products').forEach((section) => {
      section.querySelectorAll('.rhp-home-products__button').forEach((button) => {
        const label = button.querySelector('.rhp-home-products__button-label');
        if (label) label.textContent = labelText;

        let icon = button.querySelector('.rhp-home-products__button-icon');
        if (!icon) {
          icon = document.createElement('span');
          icon.className = 'rhp-home-products__button-icon';
          icon.setAttribute('aria-hidden', 'true');
          button.append(icon);
        }

        if (!icon.querySelector('svg.bbw-atc__icon')) {
          icon.innerHTML = rhpHomeProductsCartIcon;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initRhpHomeProductTabs();
        repairRhpHomeProductButtons();
      },
      { once: true }
    );
  } else {
    initRhpHomeProductTabs();
    repairRhpHomeProductButtons();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRhpHomeProductTabs(event.target);
    repairRhpHomeProductButtons(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initStatsMotion = () => {
      document.querySelectorAll('[data-rhp-stats-motion]').forEach((section) => {
        if (section.dataset.motionReady === 'true') return;
        section.dataset.motionReady = 'true';

        const counters = Array.from(section.querySelectorAll('[data-rhp-counter]'));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const setFinalValues = () => {
          counters.forEach((counter) => {
            const target = Number(counter.dataset.countTarget || 0);
            const suffix = counter.dataset.countSuffix || '';
            counter.textContent = `${new Intl.NumberFormat('en-US').format(target)}${suffix}`;
          });
        };

        const animateCounters = () => {
          if (reducedMotion) {
            setFinalValues();
            return;
          }

          counters.forEach((counter) => {
            const suffix = counter.dataset.countSuffix || '';
            counter.textContent = `0${suffix}`;
          });

          const start = performance.now();
          const duration = 1250;
          const tick = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            counters.forEach((counter) => {
              const target = Number(counter.dataset.countTarget || 0);
              const suffix = counter.dataset.countSuffix || '';
              const value = Math.round(target * eased);
              counter.textContent = `${new Intl.NumberFormat('en-US').format(value)}${suffix}`;
            });
            if (progress < 1) window.requestAnimationFrame(tick);
          };
          window.requestAnimationFrame(tick);
        };

        if (reducedMotion || !('IntersectionObserver' in window)) {
          section.classList.add('is-visible');
          setFinalValues();
          return;
        }

        section.classList.add('is-ready');
        let hasEntered = false;
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) {
              hasEntered = false;
              return;
            }
            if (hasEntered) return;
            hasEntered = true;
            section.classList.add('is-visible');
            animateCounters();
            
          },
          { threshold: 0.08 }
        );
        observer.observe(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatsMotion, { once: true });
    } else {
      initStatsMotion();
    }

    document.addEventListener('shopify:section:load', initStatsMotion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhp-home-video-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rhp-video-strip')) {
    customElements.define(
      'rhp-video-strip',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.revealTimers = new Map();
          const { signal } = this.abortController;

          this.querySelectorAll('[data-video-media]').forEach((media) => {
            const video = media.querySelector('video');
            const button = media.querySelector('[data-video-play]');
            if (!video || !button) return;

            button.addEventListener('click', () => this.toggle(video, button), { signal });
            video.addEventListener('click', () => {
              if (video.paused) {
                this.play(video, button);
              } else {
                this.reveal(button);
              }
            }, { signal });
            video.addEventListener('play', () => this.update(button, true), { signal });
            video.addEventListener('pause', () => this.update(button, false), { signal });
            video.addEventListener('loadeddata', () => {
              media.dataset.videoReady = 'true';
            }, { signal, once: true });
            video.addEventListener('ended', () => {
              video.currentTime = 0;
              this.update(button, false);
            }, { signal });
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.revealTimers?.forEach((timer) => window.clearTimeout(timer));
          this.querySelectorAll('video').forEach((video) => video.pause());
        }

        toggle(video, button) {
          if (video.paused) {
            this.play(video, button);
          } else {
            video.pause();
          }
        }

        play(video, button) {
          this.querySelectorAll('video').forEach((candidate) => {
            if (candidate !== video) candidate.pause();
          });
          this.loadVideo(video);
          video.play().catch(() => this.update(button, false));
        }

        loadVideo(video) {
          if (video.dataset.loaded === 'true') return;
          const source = document.createElement('source');
          source.src = video.dataset.videoSrc;
          source.type = 'video/mp4';
          video.append(source);
          video.dataset.loaded = 'true';
          video.load();
        }

        reveal(button) {
          const activeTimer = this.revealTimers.get(button);
          if (activeTimer) window.clearTimeout(activeTimer);
          button.dataset.visible = 'true';
          const timer = window.setTimeout(() => {
            delete button.dataset.visible;
            this.revealTimers.delete(button);
          }, 1200);
          this.revealTimers.set(button, timer);
        }

        update(button, isPlaying) {
          button.dataset.playing = String(isPlaying);
          if (!isPlaying) delete button.dataset.visible;
          const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;
          if (label) {
            button.setAttribute('aria-label', label);
            button.title = label;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
